module.exports = __webpack_public_path__ + "static/media/usericon.03784007.png";